<script>
export default {
  name: "ForumListItem",
  props: {
    itemData: {
      type: Object
    }
  },
  computed: {
    avatarSrc() {
      return `/viewimage?type=forum&?&sh=${this.itemData.imgHash}`;
    },
  },
}
</script>

<template>
<div class="forum-search-item">
  <img :src="avatarSrc" class="forum-search-item__avatar"/>
  <router-link :to="{name: 'forum', params: {id: itemData.id}}"
               target="_blank"
               class="forum-search-item__name"
  >{{ itemData.name }}</router-link>
</div>
</template>

<style lang="scss" scoped>
.forum-search-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  &__avatar {
    height: 75px;
    width: auto;
    margin-right: 15px;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>